import { useMemo } from "react";
import { hasRole, hasRoles, isRoot } from "../../../core/Global";
import SideMenu, { ISideMenuItem } from "../../../components/layouts/aside/SideMenu";


export function useAccountsSideMenuItems(): ISideMenuItem[] {
    return useMemo<ISideMenuItem[]>(() => {

        const menu: ISideMenuItem[] = []

        if (isRoot() || hasRoles([
            "ManageAdmins",
            "ManageAgents",
            "ManageTechnicians",
        ])) {
            menu.push({ seperator: true, name: "Accounts" })
        }

        if (isRoot()) {
            menu.push({ id: "customers", name: "Customers", icon: "user-secret", link: "/accounts/customers" })
            menu.push({ id: "paused", name: "Paused Accounts", icon: "pause", link: "/accounts/paused" })
        }

        if (hasRole("ManageAdmins")) {
            menu.push({ id: "admins", name: "Admins", icon: "user-tie", link: "/accounts/admins" })
        }

        if (hasRole("ManageAgents")) {
            menu.push({ id: "agents", name: "Agents", icon: "user-headset", link: "/accounts/agents" })
        }

        if (hasRole("ManageTechnicians")) {
            menu.push({ id: "technicians", name: "Technicians", icon: "user-helmet-safety", link: "/accounts/technicians" })
        }

        if (!isRoot() && hasRoles(["ManageDepartmetns", "ManageShiftTypes", "ShiftCalendar"])) {
            menu.push({ seperator: true, name: "Shifts" })
        }

        if (!isRoot() && hasRole("ManageDepartmetns")) {
            menu.push({ id: "departments", name: "Departments", icon: "diagram-project", link: "/accounts/departments" })
        }

        if (!isRoot() && hasRole("ManageShiftTypes")) {
            menu.push({ id: "shift-types", name: "Shift Types", icon: "business-time", link: "/accounts/shift-types" })
        }

        if (!isRoot() && hasRole("ShiftCalendar")) {
            menu.push({ id: "shift-calendar", name: "Shift Calendar", icon: "calendar", link: "/accounts/shift-calendar" })
        }


        const settingsItems: ISideMenuItem[] = []

        if (hasRole("UserGroupsList")) {
            settingsItems.push({ id: "usergroups", name: "User Groups", icon: "users", link: "/accounts/usergroups" })
        }

        if (hasRole("ManageTechnicians")) {
            settingsItems.push({ id: "techgroups", name: "Technician Groups", icon: "users", link: "/accounts/techgroups" })
        }

        if (hasRole("SystemSettings")) {
            settingsItems.push({ id: "tech-settings", name: "Technician Settings", icon: "user-helmet-safety", link: "/accounts/settings/techs" })
        }

        if (settingsItems.length > 0) {
            menu.push({ seperator: true, name: "Settings" })
            for (const it of settingsItems) menu.push(it)
        }

        if (isRoot()) {
            menu.push({ seperator: true, name: "Default Roles" })
            menu.push({ id: "roles-customer", name: "Customer", icon: "user-secret", link: "/accounts/roles/type/customer" })
            menu.push({ id: "roles-admin", name: "Admin", icon: "user-tie", link: "/accounts/roles/type/admin" })
            menu.push({ id: "roles-dispatcher", name: "Agent", icon: "user-headset", link: "/accounts/roles/type/dispatcher" })
        }


        return menu

    }, [])
}


export default function AccountsSideMenu() {
    const items = useAccountsSideMenuItems()
    return <SideMenu items={items} />
}
